import React from 'react';

import styles from './list-item-header.scss';

export const ListItemHeader: React.FC<React.PropsWithChildren> = ({ children }) =>
  <div className={styles.headerWrapper}>
    {children}
  </div>;
